import { render } from "./EditBASTProxy.vue?vue&type=template&id=497270fc&scoped=true"
import script from "./EditBASTProxy.vue?vue&type=script&lang=js"
export * from "./EditBASTProxy.vue?vue&type=script&lang=js"

import "./EditBASTProxy.vue?vue&type=style&index=0&id=497270fc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497270fc"]])

export default __exports__